import { apiClient } from './base';

const NAMESPACE = 'salesReport';

export const getSalesReportSettings = async () => {
  try {
    const response = await apiClient.get(`/business-settings/${NAMESPACE}`);
    return response.data.settings || {};
  } catch (error) {
    throw error;
  }
};

export const saveSalesReportSettings = async (settings) => {
  try {
    const response = await apiClient.put(`/business-settings/${NAMESPACE}`, { settings });
    return response.data.settings;
  } catch (error) {
    throw error;
  }
};
